module.exports = __webpack_public_path__ + "img/939-7de711.png";